module.exports = "<div class=\"keyboard-container\" id=\"{{::vm.keyboardId}}\"></div>\r\n";